export const SDK_LATEST = 'sdk.latest'
export const ARCHIVES = 'archives'



// WEBPACK FOOTER //
// ./src/constants/storage.js